import { Text } from "../cores";

const IconGoodChooice = () => {
  return (
    <Text
      as={"span"}
      sx={{
        color: "primaryScale.7",
        fontWeight: "bold",
        paddingY: "2xs",
        paddingX: "xs",
        backgroundColor: "primaryScale.1",
        borderRadius: "lg",
        width: "fit-content",
        marginY: "auto",
        whiteSpace: "nowrap",
        minWidth: "fit-content",
        boxShadow:
          "0px 2px 5px -1px rgb(50 50 93 / 25%), 0px 1px 3px -1px rgb(0 0 0 / 30%)",
      }}
    >
      BRA VAL
    </Text>
  );
};

export default IconGoodChooice;
